import { Area, AreaChart } from "recharts";
import { ClientOnly } from "~/components/ui/client-only";

interface SparklineProps {
	data: (number | null)[];
}

export function Sparkline({ data }: SparklineProps) {
	const chartData = data.map((value, idx) => ({ idx, value }));

	return (
		<ClientOnly fallback={<div className="h-6 w-20" />}>
			<div className="h-6 w-20">
				<AreaChart
					width={80}
					height={24}
					data={chartData}
					margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
				>
					<defs>
						<linearGradient id="sparkGradient" x1="0" y1="0" x2="0" y2="1">
							<stop offset="0%" stopColor="var(--color-chart-1)" stopOpacity={0.3} />
							<stop offset="100%" stopColor="var(--color-chart-1)" stopOpacity={0} />
						</linearGradient>
					</defs>
					<Area
						type="monotone"
						dataKey="value"
						stroke="var(--color-chart-1)"
						strokeWidth={1.5}
						fill="url(#sparkGradient)"
						dot={false}
						isAnimationActive={false}
						connectNulls
					/>
				</AreaChart>
			</div>
		</ClientOnly>
	);
}
